export default "__VITE_ASSET__D8i5gXA6__"